import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {FlowModule} from '@fantasmagames/slot/src/modules/flow/FlowModule';
import {QueueEventsHandler} from '@fantasmagames/slot/src/modules/flow/states/QueueEventsHandler';
import {IEventManagerWithAsync} from '@fantasmagames/core/src/events/_interfaces/IEventManager';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';
import {WinPresentationEvents} from '@fantasmagames/slot/src/modules/winpresentation/WinPresentationEvents';
import {BigWinEvents} from '@fantasmagames/slot/src/modules/bigwin/BigWinEvents';
import {WinUtils} from '@fantasmagames/slot/src/logic/WinUtils';

export class FlowWinningState extends ModuleState<null, FlowModule> {
	protected _queueEvents: QueueEventsHandler;

	protected handler: any;

	constructor(module: FlowModule, name: string, eventManager: IEventManagerWithAsync) {
		super(module, name);
		this._queueEvents = new QueueEventsHandler(eventManager);

		this.handler = this.onKey.bind(this);
		document.addEventListener('keydown', this.handler, true);
	}

	protected onKey(event: KeyboardEvent): void {
		if (!__PRODUCTION__) {
			if (event.code === 'KeyZ') {
				console.log(`from class: ${this.constructor.name}`);
				if (this._queueEvents) {
					this._queueEvents.printData();
				}
			}
		}
	}

	public onEnterState(): void {
	}

	public onLeaveState(): void {
		this._queueEvents.clearEventsQueue();
	}

	public handle(id: string, data?: any): void {
		super.handle(id, data);

		this._queueEvents.handleWaitingList(id, data);
	}

	protected setupEvents(): void {
	}

	protected sendOutCanSpin(): void {
		this.emit(FlowModuleEvents.CAN_SPIN);
	}

	protected setupCantSpinNoWin(): void {
		this.emit(FlowModuleEvents.NO_WIN);
	}

	protected setupNoWin(): void {
		this.emit(FlowModuleEvents.NO_WIN);
		this.sendOutCanSpin();
		this.gotoBasicState();
	}

	protected setupCantSpinWin(): void {
		this.emit(FlowModuleEvents.WON);
	}

	protected setupWin(): void {
		this.emit(FlowModuleEvents.WON);
		this._queueEvents.addEventToWaitingList(WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents.CAN_SPIN);
		this._queueEvents.addEventToWaitingList(FlowModuleEvents.CAN_SPIN, FlowModuleEvents.START_INDIVIDUAL_WIN);

	}

	protected setupCantSpinBigWin(): void {
		this.emit(FlowModuleEvents.WON_BIG_WIN);
	}

	protected setupBigWin(): void {
		this._queueEvents.addEventToWaitingList(BigWinEvents.FINISHED, FlowModuleEvents.WON);
		this._queueEvents.addEventToWaitingList(WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents.CAN_SPIN);
		this._queueEvents.addEventToWaitingList(FlowModuleEvents.CAN_SPIN, FlowModuleEvents.START_INDIVIDUAL_WIN);
		this.emit(FlowModuleEvents.WON_BIG_WIN);
	}

	protected gotoBasicState(): void {
		this.module.logic.killRestore();
		this.module.gotoState(FlowModule.BASIC_STATE);
	}

	protected setupBigWinNoIndividualNoSpin(): void {
		this.emit(FlowModuleEvents.WON_BIG_WIN);
		this._queueEvents.addEventToWaitingList(BigWinEvents.FINISHED, FlowModuleEvents.WON);
	}

	protected isWin(): boolean {
		return WinUtils.isWin(this.module.logic);
	}

	protected isSpinWin(): boolean {
		return WinUtils.isSpinWin(this.module.logic);
	}

	protected isBigWin(): boolean {
		return WinUtils.isBigWin(this.module.logic);
	}

	protected isBigWinTotalWin(): boolean {
		return WinUtils.isTotalWinBigWin(this.module.logic);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/flow/states/FlowWinningState.ts